import React from "react";
import { useTranslation } from "react-i18next";

const EditModeSlot = ({ identifier, name }) => {
  const { t: translate } = useTranslation();
  
  return (
    <div
      className={`item transition-colors duration-300 dark:bg-gray-400 dark:text-white dark:border-gray-600 text-primary-900 cursor-grab active:cursor-grabbing active:bg-primary-100 border p-4 border-primary-800 hover:border-primary-500 hover:text-primary-500 rounded select-none relative ${identifier}`}
      data-swapy-item={identifier}
    >
      <div className="w-full h-full flex items-center justify-center">
        {translate(name)}
      </div>
    </div>
  );
};

export default EditModeSlot;
